const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* ==========================================================================
   Eden GWP ($500+) - <tcz-eden-gwp> bag module behaviour.
   Lives here (a script every page loads) because the bag drawer's HTML is
   fetched after page load, and scripts inside fetched HTML never run.
   Markup/styles: snippets/tcz-eden-gwp.liquid. Remove this block to retire.
   ========================================================================== */
(function () {
  if (customElements.get('tcz-eden-gwp')) return;

  var SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function renderSections(sections) {
    if (!sections) return false;
    var done = false;
    SECTIONS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !sections[id]) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var inner = doc.querySelector('.shopify-section');
      if (inner) {
        el.innerHTML = inner.innerHTML;
        done = true;
      }
    });
    return done;
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTIONS.join(','))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!renderSections(json)) window.location.reload();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () { window.location.reload(); });
  }

  class TczEdenGwp extends HTMLElement {
    connectedCallback() {
      this.selectedVariant = null;
      this.markGiftLines();
      this.bind();
      this.enforce();
    }

    // Tags the gift row in the bag so it reads "Complimentary gift" with no qty stepper.
    markGiftLines() {
      var drawer = document.getElementById('mini-cart');
      if (!drawer) return;
      this.giftLines().forEach(function (line) {
        var variantId = line.key.split(':')[0];
        var li = drawer.querySelector('.mini-cart__navigation li[data-variant-id="' + variantId + '"]');
        if (li) li.setAttribute('data-tcz-gwp', '');
      });
    }

    giftLines() {
      return (this.dataset.giftLines || '').split(',').filter(Boolean).map(function (s) {
        var i = s.lastIndexOf('|');
        return { key: s.slice(0, i), qty: parseInt(s.slice(i + 1), 10) || 0 };
      });
    }

    // Keeps the bag honest: removes the gift below $500, and holds it to one.
    enforce() {
      var lines = this.giftLines();
      if (!lines.length) return;
      var eligible = this.dataset.eligible === 'true';
      var updates = {};
      var changed = false;

      lines.forEach(function (line, i) {
        var want = eligible && i === 0 ? 1 : 0;
        if (line.qty !== want) {
          updates[line.key] = want;
          changed = true;
        }
      });

      if (!changed || TczEdenGwp.busy || TczEdenGwp.attempts > 3) return;
      TczEdenGwp.busy = true;
      TczEdenGwp.attempts = (TczEdenGwp.attempts || 0) + 1;

      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(refresh)
        .finally(function () { TczEdenGwp.busy = false; });
    }

    bind() {
      var self = this;
      this.addBtn = this.querySelector('[data-gwp-add]');
      this.errorEl = this.querySelector('[data-gwp-error]');

      this.querySelectorAll('[data-gwp-colour]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.selectColour(btn.dataset.gwpColour); });
      });

      this.querySelectorAll('[data-gwp-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.querySelectorAll('[data-gwp-variant]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          self.selectedVariant = btn.dataset.gwpVariant;
          if (self.addBtn) self.addBtn.disabled = false;
          self.showError('');
        });
      });

      if (this.addBtn) {
        this.addBtn.addEventListener('click', function () { self.add(); });
      }
    }

    selectColour(handle) {
      this.querySelectorAll('[data-gwp-colour]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.gwpColour === handle ? 'true' : 'false');
      });
      this.querySelectorAll('[data-gwp-sizes]').forEach(function (g) {
        g.hidden = g.dataset.gwpSizes !== handle;
      });
      this.querySelectorAll('[data-gwp-img]').forEach(function (img) {
        img.hidden = img.dataset.gwpImg !== handle;
      });
      this.querySelectorAll('[data-gwp-variant]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      this.selectedVariant = null;
      if (this.addBtn) this.addBtn.disabled = true;
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = !msg;
    }

    add() {
      var self = this;
      if (!this.selectedVariant) {
        this.showError('Please select your size.');
        return;
      }
      this.addBtn.classList.add('is-loading');
      this.addBtn.textContent = 'Adding…';

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(this.selectedVariant), quantity: 1, properties: { _tcz_gwp: 'Eden Dress GWP' } }],
          sections: SECTIONS.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            self.addBtn.classList.remove('is-loading');
            self.addBtn.textContent = 'Add my free gift';
            self.showError('Sorry, that size has just sold out. Please choose another.');
            return;
          }
          if (!renderSections(res.json.sections)) return refresh();
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          self.addBtn.classList.remove('is-loading');
          self.addBtn.textContent = 'Add my free gift';
          self.showError('Something went wrong. Please try again.');
        });
    }
  }

  customElements.define('tcz-eden-gwp', TczEdenGwp);
})();